import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Grid,
  Chip
} from '@mui/material';
import {
  School,
  AdminPanelSettings,
  Edit,
  Person
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

function Login() {
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accessCode.trim()) {
      setError('Введите код доступа');
      return;
    }

    setLoading(true);
    setError('');

    const result = await login(accessCode.trim());

    if (!result.success) {
      setError(result.error);
    }

    setLoading(false);
  };

  const roleInfo = [
    {
      role: 'student',
      title: 'Студент',
      icon: <Person />,
      description: 'Прохождение курсов и выполнение заданий',
      color: 'primary'
    },
    {
      role: 'author',
      title: 'Автор курсов',
      icon: <Edit />,
      description: 'Создание и управление контентом курсов',
      color: 'secondary'
    },
    {
      role: 'admin',
      title: 'Администратор',
      icon: <AdminPanelSettings />,
      description: 'Управление пользователями и системой',
      color: 'error'
    }
  ];

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 4,
          marginBottom: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            mb: 4
          }}
        >
          <Box display="flex" alignItems="center" mb={2}>
            <School sx={{ fontSize: 35, mr: 2, color: 'primary.main' }} />
            <Typography component="h2" variant="h4" color="primary">
              Корпоративный портал обучения
            </Typography>
          </Box>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
            Платформа для создания и прохождения образовательных курсов
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%', maxWidth: 400 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="accessCode"
              label="Код доступа"
              name="accessCode"
              autoComplete="off"
              autoFocus
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value)}
              disabled={loading}
              placeholder="Например: STUDENT-001"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3, mb: 2, py: 1.5 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Войти в систему'}
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Обратитесь к администратору для получения кода доступа
          </Typography>
        </Paper>

       
      

        
      </Box>
    </Container>
  );
}

export default Login;
